export const apiCreate = (): string => '/financial/paymentGateways/'
export const apiList = (id?: string): string =>
  !id ? '/financial/paymentGateways/' : `/financial/paymentGateways/view/${id}`
export const apiUpdate = (id: string): string =>
  `/financial/paymentGateways/update/${id}`
export const apiDelete = (id: string): string =>
  `/financial/paymentGateways/${id}`
